"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSWysdomArticlesComponent = void 0;
const dynamic_articles_service_1 = require("./dynamic-articles.service");
class CSWysdomArticlesComponent {
    constructor(wysdomService) {
        this.wysdomService = wysdomService;
        this.loader = true;
        this.hasArticles = false;
    }
    ngOnInit() {
        this.wysdomService.getArticlesByTopic(this.articleTopic, this.lobValue).subscribe((res) => {
            if (res.tips) {
                this.articlesList = res.tips;
                if (res.tips && res.tips.length > 0) {
                    this.hasArticles = true;
                }
                this.loader = false;
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
}
exports.CSWysdomArticlesComponent = CSWysdomArticlesComponent;
//# sourceMappingURL=dynamic-articles.component.js.map